import { Category } from "@/types/category";
import { TodoItem } from "@/types/todo";
import CategoryCard from "@/components/todo/CategoryCard";

interface RoadmapGridProps {
  categories: Category[];
  todos: TodoItem[];
}

const RoadmapGrid = ({ categories, todos }: RoadmapGridProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">
      {categories.map((category) => (
        <CategoryCard 
          key={category.name} 
          category={category} 
          todos={todos}
        />
      ))}
    </div>
  );
};

export default RoadmapGrid;